import { type ProcedureTypeFields, type Stored } from "@overmap-ai/common"
import { selectAttachmentsOfProcedureTypeFields } from "@overmap-ai/core"
import { FieldsRenderer } from "@overmap-ai/forms"
import { cx } from "class-variance-authority"
import { type ComponentProps, memo } from "react"

import { sdk } from "../../sdk"
import { useShallowEqaulSelector } from "../../store"
import { draftCancelButtonProps, submitButtonProps } from "./constants"
import { useDeserializeFieldSchemaConfig, useFieldSchemaFromConfig, useHydrateFieldsWithAttachments } from "./hooks"

interface ProcedureTypeFieldsSubmitterProps extends Omit<
	ComponentProps<typeof FieldsRenderer>,
	"fieldSchema" | "cancelButtonProps" | "submitButtonProps"
> {
	procedureTypeFields: Stored<ProcedureTypeFields>
}

export const ProcedureTypeFieldsSubmitter = memo<ProcedureTypeFieldsSubmitterProps>((props) => {
	const { className, procedureTypeFields, ...rest } = props

	const attachments = useShallowEqaulSelector(selectAttachmentsOfProcedureTypeFields(procedureTypeFields.uuid))

	const fieldSchemaConfig = useDeserializeFieldSchemaConfig(procedureTypeFields.fields)

	const fieldSchemaConfigWithImages = useHydrateFieldsWithAttachments(
		fieldSchemaConfig,
		attachments,
		sdk.procedureTypeFieldsAttachments,
	)
	const fieldSchema = useFieldSchemaFromConfig(fieldSchemaConfigWithImages)

	return (
		<FieldsRenderer
			className={cx(className, "h-max w-full")}
			fieldSchema={fieldSchema}
			submitButtonProps={submitButtonProps}
			cancelButtonProps={draftCancelButtonProps}
			{...rest}
		/>
	)
})
ProcedureTypeFieldsSubmitter.displayName = "ProcedureTypeFieldsSubmitter"
